export const USER_ACTIONS = {
    USER_LIST : "USER_LIST"
}